<script>
import { HorizontalBar } from 'vue-chartjs'
import moment from 'moment'
export default {
    extends: HorizontalBar,
    data() {
        var devnumbers = _.map(this.devices, 'number');
        var devids = _.map(this.devices, 'id');
        var propsByDeviceId = _.groupBy(this.properties, 'device_id');
        var that = this;

        return {
            chartData: {
                datasets: [{
                    label: this.$t('routine_analyses.graphs.pieces'),
                    data: _.map(this.devices, (c) => {
                        return _.sum(
                            _.map(
                                _.filter(_.uniqBy(
                                    _.flatten(_.map(propsByDeviceId[c.id], 'property_pests_filtered')), 'id'
                                ), { pest_id: parseInt(that.pest_id) }), 'quantity')
                        );
                    }),
                    fill: false,
                    borderColor: that.color,
                    backgroundColor: that.color,
                    borderWidth: 1
                }],
                labels: devnumbers,
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: 1,
                            beginAtZero: true,
                        },
                        gridLines: {
                            display: true
                        },
                        label: this.$t('routine_analyses.graphs.devices')
                    }],
                    xAxes: [{
                        ticks: {
                            stepSize: 1,
                            beginAtZero: true,
                        },
                        gridLines: {
                            display: false
                        },
                        label: this.$t('routine_analyses.graphs.pests_quantities')
                    }]
                },
                legend: {
                    display: false
                },
                spanGaps: true,
                responsive: false,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        properties: Array,
        devices: Object,
        orderby: String,
        pest_id: String
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        orderby: function(newInspections, oldInspections) {
            var devnumbers = _.map(this.devices, 'number');
            var devids = _.map(this.devices, 'id');
            var iddevs = _.keyBy(this.devices, 'id')
            var propsByDeviceId = _.groupBy(this.properties, 'device_id');
            var that = this;
            var quantities = _.map(this.devices, (c) => {
                return [
                    c.id,
                    _.sum(
                        _.map(
                            _.filter(
                                _.uniqBy(
                                    _.flatten(_.map(propsByDeviceId[c.id], 'property_pests_filtered')), 'id'
                                ), { pest_id: parseInt(that.pest_id) }
                            ), 'quantity')
                    )
                ];
            })
            this.devices = _.sortBy(_.keys(this.devices), function(c) {
                return that.devices[c].dev_num;
            });

            if (this.orderby == 'number') {

            } else if (this.orderby == 'conditions_asc') {
                quantities = _.sortBy(quantities, [1]);
            } else if (this.orderby == 'conditions_desc') {
                quantities = _.reverse(_.sortBy(quantities, [1]));
            }

            this.chartData = {
                datasets: [{
                    label: 'Sztuk',
                    data: _.map(quantities, function(quant) { return quant[1]; }),
                    fill: false,
                    borderColor: that.color,
                    backgroundColor: that.color,
                    borderWidth: 1
                }],
                labels: _.map(quantities, function(quant) { return iddevs[quant[0]].number; }),
            };
            this.renderChart(this.chartData, this.options)
        }
    }
}
</script>